function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "134",
  height: "120"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M132.206 45.421h-.047l-26.886 11.497-36.786 15.73c-.29.122-.617.123-.909.004L29.626 56.885 2.079 45.44l-.042-.019h-.046a1.642 1.642 0 00-1.64 1.642v71.295c0 .907.734 1.641 1.64 1.642h130.215c.905 0 1.64-.735 1.64-1.642V47.063c0-.906-.735-1.64-1.64-1.642"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M132.323 45.89a.235.235 0 01-.134-.041L67.42.679a1.172 1.172 0 00-1.341.001L1.774 45.848a.235.235 0 01-.327-.057.235.235 0 01.058-.327L65.809.297a1.641 1.641 0 011.878-.004l64.77 45.17a.235.235 0 01-.134.427"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6E6",
  d: "M5.448 47.492L66.811 1.951l61.829 48.781-58.667 34.827-31.851-7.27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M40.81 107.07H10.496a1.418 1.418 0 01-.005-2.836h30.32a1.418 1.418 0 01.004 2.836h-.005zm-19.438-6.098H10.495a1.417 1.417 0 01-.004-2.836h10.88a1.417 1.417 0 011.419 1.416 1.416 1.416 0 01-1.414 1.42h-.004z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M67.674 72.857c-.23 0-.459-.044-.671-.132L29.158 57.001V7.78a1.64 1.64 0 011.64-1.642h72.601c.905 0 1.639.735 1.64 1.641v49.255l-.071.03-36.601 15.652c-.22.093-.455.14-.693.14"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M29.509 56.766L67.137 72.4c.35.143.743.14 1.093-.006l36.457-15.591V7.78a1.29 1.29 0 00-1.288-1.29H30.797a1.291 1.291 0 00-1.288 1.29v48.986zm38.165 16.208c-.245 0-.488-.047-.716-.14L29.04 57.079V7.78c0-.97.787-1.758 1.756-1.759H103.4a1.76 1.76 0 011.757 1.76v49.331L68.412 72.825c-.233.099-.484.15-.738.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M133.026 118.359c0 .647-.525 1.172-1.171 1.172H1.639a1.17 1.17 0 01-1.17-1.172V47.063c0-.63.497-1.147 1.126-1.173l27.68 11.501 37.772 15.695c.409.166.867.164 1.274-.007l36.6-15.652 26.98-11.537a1.177 1.177 0 011.125 1.173v71.296zm-1.171-72.937h-.047L104.92 56.918l-36.785 15.73c-.29.122-.618.123-.909.004L29.275 56.885 1.728 45.44l-.042-.018H1.64a1.64 1.64 0 00-1.639 1.641v71.296c0 .906.734 1.64 1.64 1.64h130.215a1.64 1.64 0 001.64-1.64V47.063c0-.906-.735-1.64-1.64-1.641z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#34C37D",
  d: "M67.185 23.208c8.734 0 15.814 7.09 15.814 15.838 0 8.746-7.08 15.837-15.815 15.837s-15.815-7.09-15.815-15.837 7.08-15.838 15.816-15.838"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "3",
  d: "M61.654 39.972l2.996 3.122 7.778-8.102"
}))));